import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var VehicleService = /** @class */ (function () {
    function VehicleService(http, config) {
        this.http = http;
        this.config = config;
    }
    VehicleService.prototype.datatable = function (data) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/vehicles/dt", data);
    };
    VehicleService.prototype.getCategoriesByMaxPax = function (maxPasseggeri) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/vehicles/categories?f=add&p=" + maxPasseggeri);
    };
    VehicleService.prototype.getAllCategories = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/vehicles/categories");
    };
    VehicleService.prototype.getAll = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/vehicles/all");
    };
    VehicleService.prototype.get = function (id) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/vehicles/" + id);
    };
    VehicleService.prototype.delete = function (id) {
        return this.http.delete(this.config.getConfig("apiEndpoint") + "/vehicles/" + id);
    };
    VehicleService.prototype.update = function (v) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/vehicles", v);
    };
    VehicleService.prototype.wizardInsert = function (v) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/vehicles/wizard", v);
    };
    VehicleService.prototype.insert = function (v) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/vehicles", v);
    };
    VehicleService.ngInjectableDef = i0.defineInjectable({ factory: function VehicleService_Factory() { return new VehicleService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: VehicleService, providedIn: "root" });
    return VehicleService;
}());
export { VehicleService };
